import type { ReactNode } from "react";
import { useAuth } from "@clerk/clerk-react";

export { ClerkProvider, SignIn, SignUp, UserButton, useAuth, useUser } from "@clerk/clerk-react";

export function Show({ when, children }: { when: "signed-in" | "signed-out"; children: ReactNode }) {
  const { isLoaded, isSignedIn } = useAuth();
  if (!isLoaded) return null;
  return (when === "signed-in" ? isSignedIn : !isSignedIn) ? children : null;
}
